var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "k-object-base",
      class: { inline: _vm.inline },
    },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("h2", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.inline ? "" : _vm.title)),
          ]),
          _c(
            "transition",
            { attrs: { name: "fade", appear: "" } },
            [
              _vm.pages > 1
                ? _c(
                    "k-pager",
                    _vm._b(
                      {
                        attrs: { value: _vm.page, "show-end": "" },
                        on: { input: _vm.gotoPage },
                      },
                      "k-pager",
                      { pages: _vm.pages, perPage: _vm.perPage },
                      false
                    )
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-btn-icon",
            {
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.refresh.apply(null, arguments)
                },
              },
            },
            [_c("i-reload")],
            1
          ),
          _c(
            "transition",
            { attrs: { name: "fade", appear: "" } },
            [
              _vm.loading || !_vm.thisObjects
                ? _c("d-loading", {
                    attrs: {
                      "spinner-size": "var(--s-3q)",
                      "spinner-thickness": "1px",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _vm.thisObjects && !_vm.thisObjects.length
            ? _c("div", { key: "empty", staticClass: "body" }, [
                _c("div", { staticClass: "empty" }, [
                  _vm._v("There are no items"),
                ]),
              ])
            : _vm.inline
            ? _c(
                "div",
                {
                  directives: [{ name: "bar", rawName: "v-bar" }],
                  key: _vm.page,
                  staticClass: "body",
                },
                [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    _vm._l(_vm.thisObjects, function (object) {
                      return _c(
                        _vm.itemBlock,
                        _vm._b(
                          {
                            key:
                              (object.error_data &&
                                object.error_data.ach_access_denied &&
                                object.error_data.ach_access_denied.redirect) ||
                              object.id,
                            tag: "component",
                            attrs: {
                              selected: !!_vm.selected[object.id],
                              actions: _vm.preprocessActions(_vm.itemActions, {
                                model: _vm.model,
                                item: object,
                              }),
                            },
                            on: {
                              refresh: _vm.refresh,
                              select: _vm.selectItem,
                            },
                          },
                          "component",
                          {
                            model: _vm.model,
                            object: object,
                            icons: _vm.icons,
                            selecting: _vm.selecting,
                          },
                          false
                        )
                      )
                    }),
                    1
                  ),
                ]
              )
            : _c(
                "div",
                { key: _vm.page, staticClass: "body" },
                _vm._l(_vm.thisObjects, function (object) {
                  return _c(
                    _vm.itemBlock,
                    _vm._b(
                      {
                        key:
                          (object.error_data &&
                            object.error_data.ach_access_denied &&
                            object.error_data.ach_access_denied.redirect) ||
                          object.id,
                        tag: "component",
                        attrs: {
                          selected: !!_vm.selected[object.id],
                          actions: _vm.preprocessActions(_vm.itemActions, {
                            model: _vm.model,
                            item: object,
                          }),
                        },
                        on: { refresh: _vm.refresh, select: _vm.selectItem },
                      },
                      "component",
                      {
                        model: _vm.model,
                        object: object,
                        icons: _vm.icons,
                        selecting: _vm.selecting,
                      },
                      false
                    )
                  )
                }),
                1
              ),
        ]
      ),
      _c(
        "div",
        { staticClass: "foooter" },
        [
          _vm.groupActions && _vm.groupActions.length && _vm.selecting
            ? _c(
                "k-actions-icons",
                _vm._b(
                  {
                    attrs: {
                      items: Object.values(_vm.selected),
                      actions: _vm.groupActions,
                    },
                    on: { refresh: _vm.refresh },
                  },
                  "k-actions-icons",
                  { model: _vm.model, icons: _vm.icons },
                  false
                )
              )
            : _vm._e(),
          !_vm.inline
            ? _c(
                "k-actions",
                _vm._b(
                  { attrs: { type: "icon-text" } },
                  "k-actions",
                  { model: _vm.model, actions: _vm.actions, icons: _vm.icons },
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }